import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ButtonLink, OnlyInDesktop, OnlyInTabletMobile } from '@components/shared';
import { RawSelect } from '@components/shared/forms';
import { useHistory } from 'react-router-dom';
import routes from '@root/routes';
import s from './Portfolio.module.less';

type Props = {
  marketSlugs: string[];
  selectedRegionSlug: string;
  landlordSlug: string;
};

const RegionButtonGroup = ({ marketSlugs, selectedRegionSlug, landlordSlug }: Props) => {
  const { t } = useTranslation('');
  const flags = useFlags();
  const history = useHistory();
  return marketSlugs.length > 1 ? (
    <>
      <OnlyInDesktop>
        <div className="mt-4 flex justify-center gap-1">
          {marketSlugs.map(marketSlug => (
            <ButtonLink
              className={cn(marketSlug === selectedRegionSlug && s.selected)}
              type="tertiary"
              key={marketSlug}
              size="medium"
              href={`${routes.landlords(landlordSlug)}?market=${marketSlug}`}
            >
              {flags['public-london-market']
                ? t(`common:markets.${marketSlug}`)
                : t(`common:deprecatedMarkets.${marketSlug}`)}
            </ButtonLink>
          ))}
        </div>
      </OnlyInDesktop>
      <OnlyInTabletMobile>
        <div className="flex mobile:justify-center">
          <RawSelect
            name="marketSlug"
            className={s.buttonsDeviceSelect}
            value={selectedRegionSlug}
            onChange={slug => history.push(`${routes.landlords(landlordSlug)}?market=${slug}`)}
            options={marketSlugs.map(marketSlug => ({
              value: marketSlug,
              label: flags['public-london-market']
                ? t(`common:markets.${marketSlug}`)
                : t(`common:deprecatedMarkets.${marketSlug}`),
            }))}
          />
        </div>
      </OnlyInTabletMobile>
    </>
  ) : null;
};

export default RegionButtonGroup;
